// @core/api/endpoints/billing/list_usage_records.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListUsageRecordsResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List usage records
 * Returns a paginated list of usage records with optional filtering by billing account, usage type, and date range.
 */
export async function ListUsageRecords(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListUsageRecordsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/usage`;
  const requestOptions = options;
  return client.get<ListUsageRecordsResponse>(requestPath, { ...requestOptions, params });
}
